module.exports = __webpack_public_path__ + "img/landingpage-bg-grey-slant.301ea688.png";